import { WHITELISTED_FIELDS } from './colaEnums';
export default function findField(qnaAnswer) {
  return WHITELISTED_FIELDS.filter(function (field) {
    return qnaAnswer.includes(field);
  });
}